import { Component } from '@verndale/core';

class VerticalImageContentRow extends Component {
  setupDefaults() {
    this.dom = {
      $imageMiddleContainer: this.el._$('.vertical-image-content__copy-middle'),
      $caption: this.el._$('.vertical-image-content__caption'),
      $copyContainer: this.el._$('.vertical-image-content__copy-container'),
      $imageContainer: this.el._$('.vertical-image-content__image-container'),
      $wrapper: this.el._$('.vertical-image-content__wrapper')
    };

    if (this.dom.$imageMiddleContainer && this.dom.$wrapper) {
      this.dom.$wrapper.classList.add(
        'vertical-image-content__wrapper--middle'
      );
    }
  }
}

export default VerticalImageContentRow;
